import SingleArticle from "./SingleArticle";

export default SingleArticle;
